import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPlayCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM10.1001 15.9837L16.4001 12.3464C16.6668 12.1925 16.6668 11.8076 16.4001 11.6536L10.1001 8.01628C9.83343 7.86232 9.5001 8.05477 9.5001 8.36269L9.5001 15.6373C9.5001 15.9452 9.83343 16.1377 10.1001 15.9837Z",
		fill: "black"
	})
});
export default SvgIconPlayCircle;
